module.exports = __webpack_public_path__ + "img/avatar.59ea4ebd.svg";